/* eslint-disable css-modules/no-unused-class  */
import { Button, Divider, Icon } from 'learning-panel-components';
import { FC } from 'react';
import moment from 'moment';
import { translate } from 'translations';
import { getPlatformUrl } from 'utils';
import styles from './assessmentBanner.module.scss';

const AssessmentBanner: FC<AssessmentBannerProps> = (props: AssessmentBannerProps) => {
    const { name, url, categories, fromDate, toDate, isStarted } = props;

    const assessmentTitle = translate('AssessmentContent');
    const assessmentSubtitle = translate('BashThisBetween');
    const pendingText = translate('Pending');
    const linkToAssessment = `${getPlatformUrl()}/${url}`;

    const getCategories = () => {
        const categoriesArray = categories.map((subtitle, index) => {
            return `#${subtitle}`;
        });
        return categoriesArray.join(', ');
    };
    return (
        <div>
            <div className={styles['assessment-banner-wrapper']}>
                <div className={styles['inner-wrapper']}>
                    <div className={styles['completed-tag']}>{pendingText}</div>
                    <div className={styles['assessment-left-wrapper']}>
                        <div className={styles['assessment-title-wrapper']}>
                            <Icon name="assessmentIconLearningPanel" style={{ marginTop: '0.3rem' }} />
                            <div className={styles['assessment-title']}>{assessmentTitle}</div>
                        </div>
                        <div className={styles['assessment-name']}>{name}</div>
                        <div className={styles['assessment-categories']}>
                            <div className={styles.category} title={getCategories()}>
                                {getCategories()}
                            </div>
                        </div>

                        <div style={{ width: '13.875rem', height: '3.3rem' }}>
                            <a href={linkToAssessment}>
                                <Button
                                    lowerCase
                                    id="user-details-submit-button"
                                    type={'gradient'}
                                    className={styles.button}
                                    text={!isStarted ? translate('Take Assessment') : translate('Continue Assessment')}
                                />
                            </a>
                        </div>
                    </div>
                    <Divider orientation="vertical" color="rgba(255, 255, 255, 0.2)" />
                    <div className={styles['assessment-right-wrapper']}>
                        <div className={styles['assessment-subtitle']}> {assessmentSubtitle}</div>
                        <div className={styles['assessment-date-wrapper']}>
                            <div className={styles.date}>{moment(fromDate).format('MMM DD ,YYYY')}</div>
                            <div className={styles.and}> {translate('and')}</div>
                            <div className={styles.date}>{moment(toDate).format('MMM DD ,YYYY')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface AssessmentBannerProps {
    name: string;
    url: string;
    categories: string[];
    fromDate: Date;
    toDate: Date;
    isStarted: boolean;
}

export default AssessmentBanner;
